var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('charts-details',{attrs:{"show":_vm.show,"chart":_vm.chart,"maschine":_vm.maschine},on:{"close-details":function($event){return _vm.$router.go(-1)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }